<template>
  <div class="header">
    <div class="header-body">
      <div class="row align-items-center justify-content-center">
        <div class="col">
          <h1 class="header-title mt-4 mb-2">Settings</h1>
        </div>
      </div>
      <CompanySettingsNavbar v-on:open-invite-modal="$emit('open-invite-modal')" />
    </div>
  </div>
</template>

<script>
import CompanySettingsNavbar from './CompanySettingsNavbar'
import { createNamespacedHelpers } from 'vuex'
const CompanyModule = createNamespacedHelpers('company')

export default {
  name: 'CompanySettingsHeader',
  components: {
    CompanySettingsNavbar
  },
  computed: {
    ...CompanyModule.mapState(['activeCompany'])
  }
}
</script>
